export default "__VITE_ASSET__B3mAGSb3__"